module.exports = "<i ng-class=\"{\n    'ion-ios-snowy' : $ctrl.storageType == 'WINTER',\n    'ion-ios-sunny' : $ctrl.storageType == 'SUMMER'}\">\n</i>\n\n<span ng-if=\"::$ctrl.withLabel\" translate>\n    {{$ctrl.storageType}}\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/wheel-storage-type-icon/wheel-storage-type-icon.html
// module id = 896
// module chunks = 0